import axios from 'axios'
import qs from 'qs'
Vue.axios = axios
import {
    Accounts,
    AccountInfo,
    SymbolList,
    MySymbolList,
    ModifySymbol,
    SearchList,
    DeleteAccount,
    Brokers,
    BindAccount,
    MyAttention,
    CancelAttention,
    MyCollection,
    MyQuestions,
    CommentQuestion,
    MyOrders,
    CancelFollow,
    UserInfo,
    ModifyUserInfo,
    AnalystBasicInfo,
    NoticeList,
    GetNoticeInfo,
    UploadFile,
    GetTags,
    SubmitArticle,
    ArticleList,
    UnPublishArticle,
    PublishDynamic,
    AnalystCertify,
    ExpertAreas,
    BrokerInfo,
    UploadTextAd,
    UploadImgAd,
    BrokerOrganizations,
    MyOpenTradeList,
    MyHistoryList,
    AddVitualAccount,
    OpenOrder,
    CloseOrder,
    CancelCollect,
    SetEaScore,
    CheckEmail,
    CheckPhone,
    SendPhoneCode,
    SendEmailCode,
    ModifyEmail,
    ModifyPhone,
    ModifyPassword,
    PublishArticle,
    ArticleToTop,
    DeleteArticle,
    GetArticleInfo,
    ModifyArticle,
    DeleteDynamic,
    GetAnalystInfo,
    SalonOnline,
    GetUserQuestions,
    AnswerQuestion,
    SalonReview,
    GetSalonQuestions,
    GetSalonPlan,
    AnalystSpeak,
    AnswerSalonQuestion,
    getCountryList,
    brokerAuth,
    getBrokerAuthInfo,
    GetAds,
    TopSpeak,
    GetAdsInfo
} from './address.js'
import { API_ROOT } from 'apiConfig'

var instance = axios.create({
    withCredentials:true, //设置跨域
    crossDomain: true
})
export default {
    /**
    * 获取我的账户列表
    */
    getAccounts: function(){
        return axios.post(Accounts);
    },
    /**
    * 获取账户信息
    */
    getAccountInfo: function(params){
        return axios.post(AccountInfo, qs.stringify(params));
    },
    /**
    * 获取行情列表
    */
    getSymbolList: function(params){
        return axios.post(SymbolList, qs.stringify(params));
    },
    /**
    * 获取主要行情列表
    */
    getMySymbolList: function(){
        return axios.post(MySymbolList);
    },
    /**
    * 修改我的自选
    */
    modifySymbol: function(params){
        return axios.post(ModifySymbol, qs.stringify(params));
    },
    /**
    * 获取历史记录的搜索条件
    */
    getSearchList: function(params){
        return axios.post(SearchList, qs.stringify(params));
    },
    /**
    * 删除账户
    */
    deleteAccount: function(params){
        return axios.post(DeleteAccount, qs.stringify(params))
    },
    /**
    * 获取经纪商列表
    */
    getBrokerList: function(){
        return axios.post(Brokers);
    },
    /**
    * 绑定交易账户
    * @param brokerType 经纪商
    * @param accountType 账户类型
    * @param platform 交易平台
    * @param accountNo 交易账户
    * @param password 交易密码
    * @param timer 时间戳
    */
    bindAccount: function(params){
        return axios.post(BindAccount, qs.stringify(params));
    },
    /**
    * 获取我的关注列表
    * @param pageNum 页码
    * @param pageSize 每页条数
    */
    getMyAttentionList: function(params){
        return axios.post(MyAttention, qs.stringify(params));
        // return axios.get(MyAttention);
    },
    /**
    * 取消关注
    * @param analystId 分析师id
    */
    cancelAttention: function(params){
        return axios.post(CancelAttention, qs.stringify(params));
    },
    /**
    * 获取我的收藏列表
    * @param pageNum 页码
    * @param pageSize 每页条数
    */
    getMyCollectionList: function(params){
        return axios.post(MyCollection, qs.stringify(params));
    },
    /**
    * 获取我的提问列表
    * @param pageNum 页码
    * @param pageSize 每页条数
    */
    getMyQuestionList: function(params){
        return axios.post(MyQuestions, qs.stringify(params));
    },
    /**
    * 对问题评分
    * @param qid 问题id
    * @param score 评分
    */
    commentQuestion: function(params){
        return axios.post(CommentQuestion, qs.stringify(params));
    },
    /**
    * 我的跟单
    * @param pageNum 页码
    * @param pageSize 条数
    * @param accountNo 账号
    */
    getMyOrders: function(params){
        return axios.post(MyOrders, qs.stringify(params));
    },
    /**
    * 解除跟单
    * @param accountNo 账号
    * @param accountType 账号类型
    * @param eaAccount ea账号
    */
    cancelFollow: function(params){
        return axios.post(CancelFollow, qs.stringify(params));
    },
    /**
    * 获取个人信息
    */
    getUserInfo: function(){
        return axios.post(UserInfo);
    },
    /**
    * 修改个人信息
    * @param nickName 昵称
    */
    modifyUserInfo: function(params){
        // return axios.post(ModifyUserInfo, qs.stringify(params));
        return axios.post(ModifyUserInfo, params);
    },
    /**
    * 获取分析师个人主页的基本信息
    */
    getAnalystBasicInfo: function(){
        return axios.post(AnalystBasicInfo);
    },
    /**
    * 获取分析师的公告列表
    * @param pageNum 页码
    * @param pageSize 条数
    */
    getNoticeList: function(params){
        return axios.post(NoticeList, qs.stringify(params));
    },
    /**
    * 上传图片
    * @param attachment 附件
    * @param random 随机数
    */
    uploadImage: function(params){
        return axios.post(UploadFile, params);
    },
    /**
    * 获取文章标签列表
    */
    getTags: function(params){
        return axios.post(GetTags, qs.stringify(params));
    },
    /**
    * 发布文章
    * @param id 文章id
    */
    submitArticle: function(params){
        return axios.post(SubmitArticle, qs.stringify(params));
    },
    /**
    * 获取分析师或经纪商文章列表'
    * @param pageNum 页码
    * @param pageSize 条数
    * @param listType 列表类型
    * @param newsType 文章类型
    */
    getArticleList: function(params){
        return axios.post(ArticleList, qs.stringify(params));
    },
    // 未发布文章--假数据
    getUnPublishArticle: function(){
        return axios.get(UnPublishArticle);
    },
    /**
    * 发布动态
    * @param content 动态内容
    * @param attachment 附件
    */
    publishDynamic: function(params){
        return axios.post(PublishDynamic, qs.stringify(params));
    },
    /**
    * 分析师认证
    */
    analystCertify: function(params){
        return axios.post(AnalystCertify, qs.stringify(params));
    },
    /**
    * 获取专家领域
    */
    getExpertAreas: function(){
        return axios.post(ExpertAreas);
    },
    /**
    * 获取经纪商信息
    */
    getBrokerInfo: function(){
        return axios.post(BrokerInfo);
    },
    /**
    * 投放文字链广告
    * @param title 广告语
    * @param textUrl 链接地址
    */
    uploadTextAd: function(params){
        return axios.post(UploadTextAd, qs.stringify(params));
    },
    /**
    * 投放图片广告
    * @param positionId 广告位位置
    * @param pic 图片地址
    * @param picUrl 链接地址
    */
    uploadImgAd: function(params){
        return axios.post(UploadImgAd, qs.stringify(params));
    },
    /**
    * 获取经纪商监管机构
    */
    getBrokerOrganizations: function(){
        return axios.post(BrokerOrganizations);
    },
    /**
    * 获取持仓记录
    * @param accountNo 交易账号
    * @param accountType 交易类型
    * @param pageNum 页码
    * @param pageSize 条数
    */
    getOpenTradeList: function(params){
        return axios.post(MyOpenTradeList, qs.stringify(params));
    },
    /**
    * 获取历史记录
    * @param symbol 交易品种
    * @param cmd 交易方向
    * @param openStartTime 开仓开始时间
    * @param openEndTime 开仓结束时间
    * @param closeStartTime 平仓开始时间
    * @param closeEndTime 平仓结束时间
    * @param tradeType 交易类型
    * @param eaAccountId EA策略账户id
    * @param accountNo 交易账号
    * @param accountType 交易类型
    * @param pageNum 页码
    * @param pageSize 条数
    */
    getHistoryList: function(params){
        return axios.post(MyHistoryList, qs.stringify(params));
    },
    test: function(){
        let params = {
            phone: '13718143306'
        };
        return instance.post('http://newsso.forex.com.cn/ssouser/fastLoginByValdaite.do', qs.stringify(params))

    },
    /**
    * 创建模拟账户
    */
    addVitualAccount: function(){
        return axios.post(AddVitualAccount);
    },
    /**
    * 自主下单
    */
    openOrder: function(params){
        return instance.post(OpenOrder, qs.stringify(params));
    },
    /**
    * 平仓
    * @param order 交易订单
    * @param accountNo 交易账号
    * @param accountType 交易类型
    */
    closeOrder: function(params){
        return axios.post(CloseOrder, qs.stringify(params));
    },
    /**
    * 取消收藏
    * @param nid 文章id
    */
    cancelCollect: function(params){
        return axios.post(CancelCollect, qs.stringify(params));
    },
    /**
    * 设置EA评分
    * @param score 评分
    * @param eaAccountId ea交易账户id
    * @param followAccount 跟随账户id
    * @param eaAccount ea交易账户
    */
    setEaScore: function(params){
        return axios.post(SetEaScore, qs.stringify(params));
    },
    /**
    * 检验手机号是否可用
    * @param phone 手机号
    */
    checkPhone: function(params){
        return axios.post(CheckPhone, qs.stringify(params));
    },
    /**
    * 检验邮箱是否可用
    * @param email 邮箱
    */
    checkEmail: function(params){
        return axios.post(CheckEmail, qs.stringify(params));
    },
    /**
    * 发送手机验证码
    * @param phone 手机号
    */
    sendPhoneCode: function(params){
        return axios.post(SendPhoneCode, qs.stringify(params));
    },
    /**
    * 发送邮箱验证码
    * @param email 邮箱
    */
    sendEmailCode: function(params){
        return axios.post(SendEmailCode, qs.stringify(params));
    },
    /**
    * 修改手机号
    * @param phone 手机号
    * @param phoneCode 手机验证码
    */
    modifyPhone: function(params){
        return axios.post(ModifyPhone, qs.stringify(params));
    },
    /**
    * 修改邮箱
    * @param email 邮箱
    * @param emailCode 邮箱验证码
    */
    modifyEmail: function(params){
        return axios.post(ModifyEmail, qs.stringify(params));
    },
    /**
    * 修改密码
    * @param oldPassword 旧密码
    * @param newPassword 新密码
    * @param confirmPassword 确认密码
    */
    modifyPassword: function(params){
        return axios.post(ModifyPassword, qs.stringify(params));
    },
    /**
    * 发布文章
    * @param title 文章标题
    * @param content 文章内容
    * @param tag1
    * @param tag2
    * @param tag3
    * @param cid 栏目id
    * @param thumb 缩略图
    * @param isPublish 是否发布
    */
    publishArticle: function(params){
        return axios.post(PublishArticle, qs.stringify(params));
    },
    /**
    * 文章置顶
    * @param id 文章id
    */
    articleToTop: function(params){
        return axios.post(ArticleToTop, qs.stringify(params));
    },
    /**
    * 删除文章
    * @param id 文章id
    */
    deleteArticle: function(params){
        return axios.post(DeleteArticle, qs.stringify(params));
    },
    /**
    * 获取文章详情信息
    * @param id 文章id
    */
    getArticleInfo: function(params){
        return axios.post(GetArticleInfo, qs.stringify(params));
    },
    /**
    * 修改文章
    * @param id 文章id
    * @param title 文章标题
    * @param content 文章内容
    * @param tag1
    * @param tag2
    * @param tag3
    * @param cid 栏目id
    * @param thumb 缩略图
    * @param isPublish 是否发布
    */
    modifyArticle: function(params){
        return axios.post(ModifyArticle, qs.stringify(params));
    },
    /**
    * 获取公告详情信息
    * @param id 公告id
    */
    getAnnoucementInfo: function(params){
        return axios.post(GetNoticeInfo, qs.stringify(params));
    },
    /**
    * 获取分析师认证信息
    */
    getAnalystInfo: function(){
        return axios.post(GetAnalystInfo);
    },
    /**
    * 获取用户提问问题列表
    * @param pageNum
    * @param pageSize
    */
    getUserQuestions: function(params){
        return axios.post(GetUserQuestions, qs.stringify(params));
        // return axios.get(GetUserQuestions);
    },
    /**
    * 回答问题
    * @param qid
    * @param answer
    */
    answerQuestion: function(params){
        return axios.post(AnswerQuestion, qs.stringify(params));
    },
    /**
    * 获取沙龙回顾列表
    */
    getSalonReview: function(){
        return axios.post(SalonReview);
    },
    /**
    * 获取分析师观点
    * @param tid 沙龙场次id
    * @param pageNum
    * @param pageSize
    * @param isAnswered 2-全部 0-未回答 1-已回答
    */
    getSalonQuestions: function(params){
        return axios.post(GetSalonQuestions, qs.stringify(params));
    },
    /**
    * 获取沙龙坐堂
    */
    getSalonOnline: function(){
        return axios.post(SalonOnline);
    },
    /**
    * 获取当月沙龙场次
    */
    getSalonPlan: function(){
        return axios.post(GetSalonPlan);
    },
    /**
    * 分析师发言
    * @param tid 沙龙场次id
    * @param content 发言内容
    * @param file 附件
    * @param isTop 是否置顶
    * @param isSync 是否同步至个人动态
    */
    analystSpeak: function(params){
        return axios.post(AnalystSpeak, qs.stringify(params));
    },
    /**
    * 回答问题
    * @param tid 沙龙场次id
    * @param answer 答案
    * @param qid 问题id
    */
    answerQuestion: function(params){
        return axios.post(AnswerQuestion, qs.stringify(params));
    },
    /**
     * 获取国家列表
     * @param country 国家名
     */
    getCountryList: function (params) {
        return axios.post(getCountryList, qs.stringify(params));
    },
    /**
     * 经纪商认证
     * @param 13参数
     */
    brokerAuth:function (params){
        return axios.post(brokerAuth, qs.stringify(params));
    },
    /**
     * 获取经纪商认证信息
     */
    getBrokerAuthInfo:function () {
        return axios.post(getBrokerAuthInfo);
    },
    /**
    * 获取经纪商广告
    */
    getAds: function(){
        return axios.post(GetAds);
    },
    /**
    * 获取经纪商或分析师主页的广告
    */
    getAdsInfo: function(){
        return axios.post(GetAdsInfo);
    }

}



// WEBPACK FOOTER //
// ./src/service/ucenter/api/index.js